<template>
  <div id="app">
    <Loading />

    <Navigation />
    <Toast />
    <transition
      name="router-animation"
      mode="out-in"
      leave-active-class="animation fadeOut"
      enter-active-class="animation fadeIn"
    >
      <router-view :key="$route.params.serialNumber"> </router-view>
    </transition>
    <Footer />
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
import Toast from './components/Toast.vue'
import Loading from './components/LoadingFullPage'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',
  components: {
    Navigation,
    Footer,
    Toast,
    Loading,
  },
  mounted: function () {
    this.$store.dispatch('rux/getAllRux')
    this.$store.dispatch('auth/checkAuth')
    this.$store.dispatch('auth/fetchUserProfile')
  },
}
</script>

<style>
@font-face {
  font-family: "Neue Medium";
  src: local("Neue Medium"), url(./fonts/NeueHaasDisplayMediu.ttf) format("truetype");
}
@font-face {
  font-family: "Neue Roman";
  src: local("Neue Roman"), url(./fonts/NeueHaasDisplayRoman.ttf) format("truetype");
}
#app {
  font-family: "Neue Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: black;
  width: 100%;
  margin: 0 auto;
  background-color: #F7F6EF;
}
body {
  margin: 0px;
  background-color: #F7F6EF;
}

input {
  border-radius: 0px;
}
.animation {
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.material-symbols-outlined {
  color: #F7F6EF;
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}
@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}
</style>
